import Vue from "vue";
import { ViewModule } from "@/store/view";
import { PluginObject } from "vue/types/umd";
import debounce from "lodash.debounce";

const onResize = debounce(() => {
  ViewModule.UPDATE_WINDOW_SIZE();
}, 100);

const plugin: PluginObject<any> = {
  install: () => {
    window.addEventListener("resize", onResize, { passive: true });
  },
};

Vue.use(plugin);
